import { render, staticRenderFns } from "./setForm.vue?vue&type=template&id=05486a09&scoped=true&"
import script from "./setForm.vue?vue&type=script&lang=js&"
export * from "./setForm.vue?vue&type=script&lang=js&"
import style0 from "./setForm.vue?vue&type=style&index=0&id=05486a09&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05486a09",
  null
  
)

export default component.exports